@if ($model() != null) {
    <div class="wrapper px-1">
        <!-- Task body: visão do executor -->
        <div class="message-container">
            <div class="message-row mb-4">
                <i class="fas fa-ban error mr-3"></i>
                <span class="headline">
                    Fluxo cancelado automaticamente pelo sistema em
                    <span class="text-highlight info-font d-inline-block">{{$dateString()}}</span>
                </span>
                <i class="fas fa-ban error ml-3"></i>
            </div>
            <hr />
            <p>
                O Fluxo
                <span class="text-highlight info-font d-inline-block">{{$flowInstance().name}}</span>
                foi configurado para que qualquer instância do mesmo seja cancelada automaticamente em caso de inatividade prolongada.
            </p>
            <p>
                Para todos os efeitos, a presente instância de Fluxo, iniciada por
                <span class="text-highlight info-font d-inline-block">{{$ownerInfo()}}</span>,
                <b>não foi completada</b> e as eventuais Tarefas previamente executadas <b>não possuem validade</b>.
            </p>
            <span>
                Inicie uma <b>nova instância</b> deste Fluxo para completar a requisição do serviço.
            </span>
        </div>
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
